import React from 'react'

type CountProps = {
    total?: number | null;
    info?: string | null
}

const CountProjects: React.FC<CountProps> = ({ total, info }) => {

    const formattedInfo = info
        ? (() => {
            const [firstWord, ...rest] = info.split(' ');
            return (
                <>
                    {firstWord} <br />
                    <b>{rest.join(' ')}</b>
                </>
            );
        })()
        : null;

    return (
        <>
            <div>
                <div style={{ textAlign: 'center', fontSize: '96px' }}>
                    <p><b>{total}</b></p>
                </div>
                <div style={{ textAlign: 'center', fontSize: '22px' }}>
                    {/* <p>{t('one_pager_report.projects')} <br /> <b>{info}</b></p> */}
                    <p>{formattedInfo}</p>
                </div>
            </div>
        </>
    )
}

export default CountProjects